const contentMapper = (content: any) => {
  const value: any = {};
  if (content.image !== undefined) value.image = content.image;

  return value;
};

export default contentMapper;
